/**
 * Feature flags convention: go/frontend-feature-flags
 */

import { ff } from '@atlassian/jira-feature-flagging';

export const isJPDDeliveryLinkTypeFilteringEnabled = () =>
	ff('polaris.jpd-panel-in-issue-view', false);
